import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared.module';
import { ComponentsModule } from '../components/components.module';

import {
  IdentificationLayoutComponent,
  CardLayoutComponent,
  MessageLayoutComponent
} from '.';

@NgModule({
  declarations: [
    IdentificationLayoutComponent,
    CardLayoutComponent,
    MessageLayoutComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ComponentsModule,
    RouterModule.forChild([])
  ],
  exports: [
    IdentificationLayoutComponent,
    CardLayoutComponent,
    MessageLayoutComponent
  ]
})
export class LayoutsModule { }
